import React from 'react';
import StatusSummaryButton from '../../../status/statusSummaryButton.jsx';
import partnerPropTypes from '../../../partnerPropTypes';

function generateData({ partner }) {
    if (partner.verificationStatus === 'NOT_VERIFIED') {
        return {
            actionRequiredType: 'NEGATIVE',
            content: `${partner.name} må bekrefte identiteten sin før du kan betale.`,
        };
    }

    return {
        actionRequiredType: 'POSITIVE',
        content: 'Gå til betaling',
        status: `${partner.name} har godtatt avtalen.`,
    };
}

const AgreementAccepted = ({ partner }) => {
    const { actionRequiredType, content, status } = generateData({ partner });
    return (
        <StatusSummaryButton
            href="/avtale-godkjent"
            statusSummary={status}
            actionRequiredType={actionRequiredType}
        >
            {content}
        </StatusSummaryButton>
    );
};

AgreementAccepted.propTypes = {
    partner: partnerPropTypes.isRequired,
};

export default AgreementAccepted;



// WEBPACK FOOTER //
// ./safeTrade/buyer/agreement/summaries/agreementAcceptedSummary.jsx